import { ComboboxSingleSelect } from '@eggplant/pattern-library'
import type {
  DropdownPlacement,
  Options,
  TestStatus
} from '@eggplant/types'

interface Props {
  value: string | undefined
  onChange: (value: TestStatus | string) => void
  dropdownPlacement?: DropdownPlacement
}

const statusOptions: Options = [
  { label: 'Passed', value: 'PASSED' },
  { label: 'Failed', value: 'FAILED' },
  { label: 'In Progress', value: 'INCOMPLETE' },
  { label: 'Error', value: 'ERROR' },
  { label: 'Cancelled', value: 'CANCELLED' }
]

const SelectTestResultsStatus = ({
  onChange,
  value,
  dropdownPlacement = 'bottom'
}: Props) =>
  <ComboboxSingleSelect
    ariaLabel='Run Status Combobox'
    dropdownPlacement={dropdownPlacement}
    isFilter
    isHighlighted={value !== ''}
    key={value}
    onChange={onChange}
    options={statusOptions}
    prompt='Run status'
    value={value}
  />

export default SelectTestResultsStatus
